import { SnackbarContent } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

class NotifySnackbar extends React.Component {
  handleClose = (event, reason) => {
    this.props.onClose();

    if (reason === 'clickaway') {
      return;
    } else if (reason === 'action') {
      this.props.onAction && this.props.onAction();
    }
  };

  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.props.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
      >
        <SnackbarContent
          aria-describedby="message-id"
          message={<span id="message-id">{this.props.message}</span>}
          className="snackbar__base"
          action={[
            <IconButton
              key="snackbar-action"
              aria-label="Action"
              color="inherit"
              onClick={e => this.handleClose(e, 'action')}
            >
              <Icon>{this.props.actionIcon}</Icon>
            </IconButton>,
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <Icon>close</Icon>
            </IconButton>,
          ]}
        />
      </Snackbar>
    );
  }
}

NotifySnackbar.propTypes = {
  actionIcon: PropTypes.string,
  onAction: PropTypes.func,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NotifySnackbar;



// WEBPACK FOOTER //
// ./src/components/Utility/Snackbars/NotifySnackbar.jsx